import styled, { css } from 'styled-components';
var Fade = styled.span.withConfig({
  displayName: "fade__Fade",
  componentId: "sc-15zktk7-0"
})(["transition:opacity 0.4s;", ""], function (_ref) {
  var state = _ref.state;

  switch (state) {
    case 'entering':
    case 'exited':
      return css(["opacity:0;"]);

    case 'entered':
    case 'exiting':
      return css(["opacity:1;"]);
  }
});
export default Fade;